import PlatformPage from '../PlatformPage';

const ForWix = () => (
  <PlatformPage
    slug="wix"
    name="Wix"
    title="Website Feedback Tool for Wix"
    description="Leave visual feedback directly on your live Wix site. One snippet in Custom Code, works on multi page and single page templates. Invisible to visitors."
    h1="Website feedback tool built for Wix sites."
    intro="Add one snippet in your Wix dashboard and your team can click on any element of the live site to leave a note pinned to that spot. Cayda handles both kinds of Wix template, the ones that reload on navigation and the ones that swap content in place."
    requirement="Custom Code on Wix needs a Premium plan."
    steps={[
      { title: 'Copy your snippet from the Cayda dashboard', desc: 'One script tag with your site’s token.' },
      { title: 'Open Settings → Custom Code', desc: 'In your Wix dashboard, not the Editor.' },
      { title: 'Click + Add Custom Code and paste the snippet', desc: 'Name it Cayda Widget.' },
      { title: 'Set it to All pages, placement Body – end, and apply', desc: 'Changes go live immediately.' },
    ]}
    loads={{
      title: 'Built for how Wix pages load',
      paragraphs: [
        'Wix templates come in two flavours. Multi page templates do a full reload on navigation, and Cayda works on first load with no configuration. Single page templates swap content and update the URL in place; Cayda’s URL polling picks up the change within a second and keeps the right notes on screen as you move around.',
        'Notes pin to the element rather than a coordinate, so they hold their place across breakpoints and dynamic sections.',
      ],
    }}
    where={{
      title: 'Where your team leaves notes',
      paragraphs: [
        'Pages, blog posts, Wix Stores product pages, dynamic pages. A strip that overflows on mobile, an image that needs replacing, a button pointing to the wrong page, copy waiting on a client. Click it, type, and the note is pinned with a screenshot, the URL, browser, OS and viewport.',
        'Notes have a type, status, priority and assignee and live in a Kanban or list dashboard across all your sites. Freelancers managing several Wix clients keep each as its own site; on the Team plan clients review through guest links at no member fee.',
      ],
    }}
    extras={[
      {
        title: 'Invisible to your visitors',
        paragraphs: [
          'The script activates only for authenticated team members and invited guests. For everyone else it renders nothing, sets no cookies and adds no meaningful weight.',
        ],
      },
    ]}
    ctaTitle="Add feedback to your Wix site."
    ctaSub="Paste the snippet into Custom Code and start leaving notes in under two minutes."
  />
);

export default ForWix;
